export const feelingsItems = [
  { label: "Arg", value: "ANGRY" },
  { label: "Ledsen", value: "SAD" },
  { label: "Glad", value: "HAPPY" },
  { label: "Fundersam", value: "THOUGHTFUL" },
  { label: "Osäker/Vill inte ange", value: "UNKNOWN" },
];
